import { Box, Flex, VStack, Divider, Button, Text } from '@chakra-ui/react';
import { ROUTERS } from '../../../data';
import { FiUser, FiUsers } from 'react-icons/fi';
import { AiOutlineStar } from 'react-icons/ai';
import { BsQrCode } from 'react-icons/bs';
import { NavSideBarFooter } from './NavSideBarFooter';
import { NavSideBarNavigationBtn } from './NavSideBarNavigationBtn';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LinkWithArrow } from '../../Links/LinkWithArrow';

export const NavSideBarContent = ({ onCloseSideBar }: { onCloseSideBar?: VoidFunction }) => {
  const { t } = useTranslation();
  return (
    <Flex minH='100%' flexDir='column' p={5} pb={{ base: 0, lg: 5 }} justifyContent='space-between'>
      <Box>
        <VStack>
          <NavSideBarNavigationBtn
            leftIcon={<AiOutlineStar size='25' />}
            to={ROUTERS.USER.SCORE}
            onClick={onCloseSideBar}
          >
            {t('user.nav.bar.score')}
          </NavSideBarNavigationBtn>

          <NavSideBarNavigationBtn leftIcon={<FiUser size='25' />} to={ROUTERS.USER.PROFILE} onClick={onCloseSideBar}>
            {t('user.nav.bar.profile')}
          </NavSideBarNavigationBtn>

          <NavSideBarNavigationBtn
            leftIcon={<FiUsers size='25' />}
            to={ROUTERS.USER.MEMBERS}
            onClick={onCloseSideBar}
            associatedPaths={[ROUTERS.USER.CREATE_AND_EDIT_MEMBER, ROUTERS.USER.MEMBER_TO_USER]}
          >
            {t('user.nav.bar.connections')}
          </NavSideBarNavigationBtn>
        </VStack>

        <NavLink to={ROUTERS.USER.QR_CODE} onClick={onCloseSideBar}>
          <Button
            variant='white'
            leftIcon={<BsQrCode color='var(--chakra-colors-brand-cyan)' size='40' />}
            w='100%'
            mt={4}
            borderRadius={10}
            minH={20}
            fontSize='lg'
          >
            <Text ml={2}>{t('user.nav.bar.qr.code')}</Text>
          </Button>
        </NavLink>

        <VStack alignItems='flex-start' mt={10}>
          <LinkWithArrow href='https://sparkx.com/het-park/attracties/' target='_blank'>
            {t('user.nav.bar.our.experiences')}
          </LinkWithArrow>
          <LinkWithArrow href='https://sparkx.com/het-park/parkplan/' target='_blank'>
            {t('user.nav.bar.park.map')}
          </LinkWithArrow>
          <LinkWithArrow href='https://sparkx.com/over-sparkx/' target='_blank'>
            {t('user.nav.bar.about.us')}
          </LinkWithArrow>
        </VStack>
      </Box>

      <Box>
        <Divider borderColor='gray.500' mt={6} />
        <NavSideBarFooter />
      </Box>
    </Flex>
  );
};
